const promotions_en = [
  /*
  {
    id: "promotion_1",
    link: "",
    // title: "CBX Plus",
    bgImageSrc: "/images/cbx_plus.jpg",
    titleImageSrc: "/images/CBX-PLUS.png",
    description:
      "With Plus you’ll find products, benefits and discounts that will help you enjoy your trip even more",
  },
  */
  {
    id: "promotion_2",
    link: "/travel-club",
    // title: "Travel Club ",
    bgImageSrc: "/images/travel_club.jpg",
    titleImageSrc: "/images/TRAVEL-CLUB-logo.png",
    description:
      "Purchase your membership today and access incredible discounts on hotels, restaurants, theme parks, and more.",
  },
];


const promotions_es = [
  /*
  {
    id: "promotion_1",
    link: "",
    // title: "CBX Plus",
    bgImageSrc: "/images/cbx_plus.jpg",
    titleImageSrc: "/images/CBX-PLUS.png",
    description:
      "Aquí encontrarás productos, beneficios y descuentos que te ayudarán a disfrutar aún más de tu viaje.",
  },
  */
  {
    id: "promotion_2",
    link: "/travel-club",
    // title: "Travel Club",
    titleImageSrc: "/images/TRAVEL-CLUB-logo.png",
    bgImageSrc: "/images/travel_club.jpg",
    description:
      "Adquiere tu membresía hoy mismo y accede a increíbles descuentos en hoteles, restaurantes, parques temáticos y más.",
  },
];

export default async function getPromotions({ locale }) {
  switch (locale) {
    case "en":
      return promotions_en;
    case "es":
      return promotions_es;
    default:
      return promotions_es;
  }
}
